module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/3_img@3x-94c5586526b8e81ff065add35481ef56.png";